export default __webpack_public_path__ + "static/media/FICHA TÉCNICA - BATATA DOCE CANADENSE.f9eb5dfd.pdf";